import { Link } from 'react-router-dom'
import { contact } from '../../data/profile'
import { OPEN_SETTINGS_EVENT } from './ConsentBanner'

const linkClass = 'inline-flex min-h-11 items-center text-ink underline underline-offset-4 hover:text-link'
const buttonClass = `${linkClass} cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-link`

function openCookieSettings() {
  window.dispatchEvent(new CustomEvent(OPEN_SETTINGS_EVENT))
}

export default function SiteFooter() {
  return (
    <footer className="border-t-2 border-ink bg-paper">
      <div className="mx-auto flex max-w-[1180px] flex-wrap gap-x-12 gap-y-4 px-4 py-8 text-sm sm:px-6">
        <div>
          <p className="font-serif text-lg font-bold text-ink">Martin Tamm</p>
          <p className="font-mono text-xs text-neutral-600">{contact.location}</p>
        </div>

        <ul className="flex flex-wrap gap-x-6">
          <li>
            <a href={`mailto:${contact.email}`} className={linkClass}>
              {contact.email}
            </a>
          </li>
          <li>
            <a href={contact.linkedin} target="_blank" rel="noopener noreferrer" className={linkClass}>
              LinkedIn
            </a>
          </li>
        </ul>

        <ul className="flex flex-wrap gap-x-6">
          <li>
            <Link to="/privacy-policy" className={linkClass}>
              Privacy
            </Link>
          </li>
          <li>
            <Link to="/terms-of-service" className={linkClass}>
              Terms
            </Link>
          </li>
          <li>
            <button type="button" onClick={openCookieSettings} className={buttonClass}>
              Cookie settings
            </button>
          </li>
          <li>
            <a href="/sitemap.xml" className={linkClass}>
              sitemap.xml
            </a>
          </li>
          <li>
            <a href="/robots.txt" className={linkClass}>
              robots.txt
            </a>
          </li>
          <li>
            <a href="/llms.txt" className={linkClass}>
              llms.txt
            </a>
          </li>
        </ul>
      </div>
    </footer>
  )
}
